<template>
  <div class="p-4 md:p-6 lg:p-8 xl:p-10 bg-app-bg-light dark:bg-app-bg-dark min-h-screen">
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-slate-800 dark:text-slate-100 mb-2">Panel de Pantallas</h1>
      <p class="text-slate-600 dark:text-slate-400">Acceso a pantallas de cocina y barra - {{ fechaActual }}</p>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all">
        <div class="text-center">
          <div class="inline-flex p-6 bg-orange-100 dark:bg-orange-900/30 rounded-2xl mb-6">
            <i class="bx bx-restaurant text-6xl text-orange-600 dark:text-orange-400"></i>
          </div>
          <h2 class="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-2">Pantalla de Cocina</h2>
          <p class="text-slate-600 dark:text-slate-400 mb-6">Visualiza los pedidos pendientes en cocina</p>
          <button
            @click="$router.push('/pantalla-cocina')"
            class="w-full bg-custom-primary text-white font-semibold py-3 px-6 rounded-lg hover:opacity-90 transition-opacity">
            Abrir Pantalla de Cocina
          </button>
        </div>
      </div>

      <div class="bg-white dark:bg-slate-800 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all">
        <div class="text-center">
          <div class="inline-flex p-6 bg-purple-100 dark:bg-purple-900/30 rounded-2xl mb-6">
            <i class="bx bx-drink text-6xl text-purple-600 dark:text-purple-400"></i>
          </div>
          <h2 class="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-2">Pantalla de Barra</h2>
          <p class="text-slate-600 dark:text-slate-400 mb-6">Visualiza los pedidos pendientes en barra</p>
          <button
            @click="$router.push('/pantalla-barra')"
            class="w-full bg-custom-primary text-white font-semibold py-3 px-6 rounded-lg hover:opacity-90 transition-opacity">
            Abrir Pantalla de Barra
          </button>
        </div>
      </div>
    </div>

    <!-- Alertas de inventario -->
    <div v-if="alertasInventario.length > 0" class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-6 shadow-sm mb-6">
      <h2 class="text-xl font-semibold text-red-800 dark:text-red-300 mb-4 flex items-center">
        <i class="bx bx-error-circle text-2xl mr-2"></i>
        Alertas de Inventario
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <div v-for="(alerta, i) in alertasInventario" :key="i" class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-red-300 dark:border-red-700">
          <p class="font-medium text-sm text-slate-800 dark:text-slate-100">{{ alerta.nombre }}</p>
          <div class="flex justify-between items-center mt-1">
            <span class="text-xs text-slate-600 dark:text-slate-400">{{ alerta.area }}</span>
            <span class="text-xs font-bold text-red-600 dark:text-red-400">
              Stock: {{ alerta.stock }} / {{ alerta.stock_minimo }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm">
      <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-4">Estado Actual</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="p-4 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">Pedidos en Cocina</span>
            <span class="text-2xl font-bold text-orange-600 dark:text-orange-400">{{ stats.pedidosCocina }}</span>
          </div>
          <p class="text-xs text-slate-500 dark:text-slate-400">Órdenes activas en preparación</p>
        </div>
        <div class="p-4 rounded-lg bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">Pedidos en Barra</span>
            <span class="text-2xl font-bold text-purple-600 dark:text-purple-400">{{ stats.pedidosBarra }}</span>
          </div>
          <p class="text-xs text-slate-500 dark:text-slate-400">Bebidas en preparación</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config/config';

export default {
  name: 'DashboardPantallas',
  data() {
    return {
      stats: {
        pedidosCocina: 0,
        pedidosBarra: 0
      },
      alertasInventario: []
    };
  },
  computed: {
    fechaActual() {
      return new Date().toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }
  },
  mounted() {
    this.cargarEstadisticas();
    this.cargarAlertasInventario();
    // Actualizar cada 10 segundos
    setInterval(() => {
      this.cargarEstadisticas();
      this.cargarAlertasInventario();
    }, 10000);
  },
  methods: {
    async cargarEstadisticas() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/pantallas`);
        this.stats = response.data;
      } catch (error) {
        console.error('Error cargando estadísticas de pantallas:', error);
      }
    },
    async cargarAlertasInventario() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/alertas-inventario-restaurante`);
        this.alertasInventario = response.data || [];
      } catch (error) {
        console.error('Error cargando alertas de inventario:', error);
      }
    }
  }
};
</script>
